import { ChamberFaultStatus } from './chamberFaultStatus';
import { ChamberFloodStatus } from './chamberFloodStatus';
import { ChamberMaintenanceStatus } from './chamberMaintenanceStatus';
import { PagedResponseModel } from './pagedResponse';
import { RainUnits } from './rainfallModel';

export interface NewSpillsResponseModel {
  reportStart: string; // date
  reportEnd: string; // date
  rainfallEnabled: boolean;
  rainfallRateUnit: RainUnits;
  results: PagedResponseModel<NewSpillModel>;
}

export interface NewSpillModel {
  siteId: number;
  siteName: string;
  address: string;
  deviceSerialNumber: string;
  deviceSmsNumber: string;
  deviceLastCallIn: string; // as date
  faultStatus: ChamberFaultStatus;
  status: ChamberFloodStatus;
  maintenanceStatus: ChamberMaintenanceStatus;
  currentEventDurationSeconds: number;
  totalEventCount: number;
  totalFloodEventWithRainfallCount: number;
  totalDepthOfRainfall: number;
  totalSecondsInSpill: number;
  totalSecondsInWarning: number;
  totalSecondsInOk: number;
  totalSecondsInMaintenance: number;
  lastNote: string;
  //
  pausedBy?: string;
  pausedUntilDate?: string; // as date
}

//

export interface SnoozeAlarmsModel {
  pauseStartDate: string; // as date
  pauseDurationDays: number; // number of days
}

export interface SnoozeAlarmsFormModel {
  pauseStartDate: Date;
  pauseDurationDays: string;
}

//

export const NewSpillsUrlFilterNames = {
  dateRange: 'DateRange',
  floodStatus: 'FloodStatus',
  maintenanceStatus: 'MaintenanceStatus',
} as const;
export type NewSpillsUrlFilterNamesType = (typeof NewSpillsUrlFilterNames)[keyof typeof NewSpillsUrlFilterNames];

export interface NewSpillsFiltersModel {
  [NewSpillsUrlFilterNames.dateRange]: NewSpillDateRangeType;
  [NewSpillsUrlFilterNames.floodStatus]: NewSpillsFloodStatusType;
  [NewSpillsUrlFilterNames.maintenanceStatus]: NewSpillsMaintenanceStatusType;
}

export type NewSpillsFilterValueType<Type extends NewSpillsUrlFilterNamesType> = Type extends 'DateRange'
  ? NewSpillDateRangeType
  : Type extends 'FloodStatus'
    ? NewSpillsFloodStatusType
    : Type extends 'MaintenanceStatus'
      ? NewSpillsMaintenanceStatusType
      : never;

//

const NewSpillsDateRange = ['Last7Days', 'Last14Days', 'Last21Days', 'Last30Days'] as const;
export type NewSpillDateRangeType = (typeof NewSpillsDateRange)[number];
export const NewSpillsDateRangeOptions: Record<NewSpillDateRangeType, string> = {
  Last7Days: 'Last 7 days',
  Last14Days: 'Last 14 days',
  Last21Days: 'Last 21 days',
  Last30Days: 'Last 30 days',
};

const NewSpillsFloodStatus = ['Spill', 'Warning', 'SpillOrWarning'] as const;
export type NewSpillsFloodStatusType = (typeof NewSpillsFloodStatus)[number];
export const NewSpillsFloodStatusOptions: Record<NewSpillsFloodStatusType, string> = {
  Spill: 'Spill',
  Warning: 'Warning',
  SpillOrWarning: 'Spill or Warning',
};

const NewSpillsMaintenanceStatus = ['New', 'Ongoing', 'Cleared', 'Maintenance'] as const;
export type NewSpillsMaintenanceStatusType = (typeof NewSpillsMaintenanceStatus)[number];
export const NewSpillsMaintenanceStatusOptions: Record<NewSpillsMaintenanceStatusType, string> = {
  New: 'New',
  Ongoing: 'Ongoing',
  Cleared: 'Cleared',
  Maintenance: 'Maintenance',
};
